module.exports = __webpack_public_path__ + "static/media/login.da815e45.jpg";